import { IApplicationState } from 'shared/types/redux';

export const selectPrefetchedOffersData = (state: IApplicationState) => state.landing.prefetchedOffersData;

export const selectPrefetchedOffersRequest = (state: IApplicationState) => state.landing.prefetchedOffersRequest;
